import { useTranslations } from "next-intl";
import { Link } from "@/app/config/navigation";
import React from "react";

function FastMenu() {
  const t = useTranslations("layout");

  const menu = [
    {
      key: t("whyUs"),
      url: "/#why-us",
    },
    {
      key: t("courses"),
      url: "/#courses",
    },
    {
      key: t("outcomes"),
      url: "/our-outcomes",
    },
    {
      key: t("blog"),
      url: "/blog",
    },
    {
      key: t("prices"),
      url: "/#prices",
    },
  ];
  return (
    <ul className="flex gap-4 flex-col items-center ">
      {menu.map((item) => (
        <Link href={item.url} key={item.key}>
          {" "}
          <li className="text-[1.4rem] text-center text-fontLight ">
            {item.key}
          </li>
        </Link>
      ))}
    </ul>
  );
}

export default FastMenu;
